import { __decorate } from "tslib";
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import taskTypeMessages from '@blade-sxp/task-management/lang/task-type';
import similaritySlider from '@blade-sxp/task-management/pages/task-result/components/similarity-slider.vue';
import datePicker from '@blade/common/components/date-time-select/index.vue';
let default_1 = class default_1 extends Vue {
    taskType;
    taskId;
    deviceId;
    defaultTime = ['00:00:00', '23:59:59'];
    isCheck = false;
    dates = [];
    form = {
        device: [],
        level: '',
        keyWord: '',
        similarity: 0,
        dateStart: '',
        dateEnd: '',
    };
    levelOptions = [
        { value: '', label: `${this.$t('all')}` },
        { value: 'CRITICAL', label: `${this.$t('critical')}` },
        { value: 'MAJOR', label: `${this.$t('major')}` },
        { value: 'MINOR', label: `${this.$t('minor')}` },
    ];
    tagList = [];
    onChangeDates(val) {
        if (!val || val.length === 0) {
            val = ['', ''];
        }
        this.form.dateStart = val[0];
        this.form.dateEnd = val[1];
    }
    onChangeForm() {
        if (this.deviceId.length > 0) {
            this.updateAlarmList();
            this.updateTagList();
        }
    }
    updateAlarmList() {
        return this.form;
    }
    updateTagList() {
        this.tagList = [];
        for (let key in this.form) {
            if (this.taskType === 'ALERT' && this.form[key] !== '') {
                if (key === 'keyWord' || key === 'similarity') {
                    this.tagList.push(this.form[key]);
                }
                else if (key === 'level') {
                    this.tagList.push(this.levelOptions.filter((item) => item.value === this.form[key])[0].label);
                }
            }
            if (key === 'device') {
                if (this.form?.device && this.form?.device.length > 0) {
                    this.form?.device.forEach((ele) => {
                        this.tagList.push(this.deviceId.filter((item) => item.value === ele)[0].label);
                    });
                }
            }
            else if ((key === 'dateStart' || key === 'dateEnd') && this.form[key] !== '') {
                this.tagList.push(this.form[key]);
            }
        }
        return this.tagList;
    }
    created() { }
    getFormSimilarity(vol) {
        this.form.similarity = vol;
    }
    handleReset() {
        this.dates = [];
        this.form = {
            device: [],
            level: '',
            keyWord: '',
            similarity: 0,
            dateStart: '',
            dateEnd: '',
        };
    }
    handleSearch() {
        this.updateAlarmList();
    }
};
__decorate([
    Prop()
], default_1.prototype, "taskType", void 0);
__decorate([
    Prop()
], default_1.prototype, "taskId", void 0);
__decorate([
    Prop()
], default_1.prototype, "deviceId", void 0);
__decorate([
    Watch('dates')
], default_1.prototype, "onChangeDates", null);
__decorate([
    Watch('form', { deep: true })
], default_1.prototype, "onChangeForm", null);
__decorate([
    Emit('updateAlarmList')
], default_1.prototype, "updateAlarmList", null);
__decorate([
    Emit('updateTagList')
], default_1.prototype, "updateTagList", null);
default_1 = __decorate([
    Component({
        name: 'task-result',
        components: {
            'similarity-slider': similaritySlider,
            datePicker,
        },
        i18n: {
            messages: taskTypeMessages,
        },
    })
], default_1);
export default default_1;
